import React, { Component } from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import { changeView } from "./../actions/assessment";
import Button from "./ui/Buttons/Button";

export class Notice extends Component {
  render() {
    return (
      <div>
        <div className="main container-fluid h-100">
          <div className="row h-100 justify-content-center align-items-center">
            <div className="col-12">
              <div className="container">
                <div className="row  justify-content-center ">
                  <div className="col-md-6 ">
                    <div className="test-info">
                      <h3 className="mt-4 mb-3 text-center">
                        <Translate value="notice" />
                      </h3>

                      <div className="row h-auto justify-content-center align-items-center px-4 py-5">
                        <p>
                          <Translate value="notice_message" />
                        </p>
                      </div>

                      <div className="button-wrap">
                        {/* <button
                          className="btn btn-main btn-global btn-block"
                          onClick={() => this.props.continue("welcome")}
                        >
                          <Translate value="cont" />
                        </button> */}
                        <Button
                          variant="primary"
                          className="btn-block"
                          onClick={() => this.props.continue("welcome")}
                        >
                          <Translate value="cont" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  continue: (view) => dispatch(changeView(view)),
});

export default connect(null, mapDispatchToProps)(Notice);
